import InputPrimary from "../Input";
import { useTranslation } from "react-i18next";

export default function InputPhone({
  phoneValue,
  setPhoneValue,
  setErrorPhone,
}) {
  const { t } = useTranslation();
  const validateInput = (value) => {
    const phoneRegex = /^\+?[0-9]\d{9}$/;

    if (value === "" || phoneRegex.test(value)) {
      setErrorPhone("");
    } else {
      setErrorPhone("invalid_phone");
    }
  };
  const handleChange = (e) => {
    const inputValue = e.target.value;
    setPhoneValue(inputValue);
    validateInput(inputValue);
  };

  return (
    <InputPrimary
      type="text"
      placeholder={t("phone")}
      value={phoneValue}
      onChange={handleChange}
    />
  );
}
